/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Grid, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import { Table, Tag } from "antd";
import { CalendarToday } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import RefreshIcon from "@mui/icons-material/Refresh";
import { GlobalStyles } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Loader from "components/custom/Loader";
import { Tooltip } from "@mui/material";
import PopAddReservation from "./Popaddreservation";
import useApiRequest from "utils/Apirequest";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import CustomMaterialTablePage from "../../components/custom/CustomMaterialTablePage";
import { convertUTCtoDubai } from "utils/Constant";
import { getDecodedUserData } from "utils/Constant";
import TableRefreshButton from "components/Loadable/TableRefreshButton";
import TotalCharger from "../../assets/cms-icons/Totalcharger.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";

function Reservation() {
  const apiRequest = useApiRequest();

  const getValues = () => {
    return {
      tag_id: "",

      charger_id: "",
      vehicleId: "",
      connectorId: "",
    };
  };
  const spinKeyframes = `
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}`;

  const [isDisabled, setIsDisabled] = useState(false);
  const [values] = useState(getValues);
  const [columnFilters, setColumnFilters] = useState([]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  const [page, setPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [sorting, setSorting] = useState([
    {
      id: "createdAt",
      desc: true,
    },
  ]);
  const [pageSize, setPageSize] = useState(20);
  const [totalRows, setTotalRows] = useState(0);
  const [columnVisibility, setColumnVisibility] = useState({});

  const handleStateChange = (newState) => {
    setIsDisabled(newState);
  };

  const handleSortingChange = (newSorting) => {
    setSorting(newSorting);
  };

  const handleSearchChange = (event) => {
    setSearchText(event);
    setPage(0);
  };

  useEffect(() => {
    setPage(pagination.pageIndex);
    setPageSize(pagination.pageSize);
  }, [pagination]);
  useEffect(() => {
    setPage(pagination.pageIndex);
    setPageSize(pagination.pageSize);
  }, [pagination]);

  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
    (async () => {

      const { data } =
        (await apiRequest(
          "get",
          `reservations/?page=${page + 1}&limit=${pageSize}&sortField=${sorting[0]?.id || ""}&sortOrder=${sorting[0]?.desc ? "desc" : "asc"
          }&search=${searchText}`,
          null,
          {},
          {}
        )) || {};
      if (data?.success === true) {
        const sortedRows = data?.data?.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setRows(sortedRows);
        setTotalRows(data?.total);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    })();
  }, [page, pageSize, sorting, searchText]);
  const handleDelete = async (row_data) => {
    const { data, } =
      (await apiRequest(
        "patch",
        "reservations/" + row_data.reservationId + "/cancel",
        null,
        {},
        {}
      )) || {};
    if (data?.status === true) {
      window.location.reload();
    }
  };
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { sidenavColor } = controller;

  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const statusList = [
    "Pending",
    "Reserved",
    "Cancelled",
    "Rejected",
    "Completed",
  ];
  const start = (event) => {
    event.preventDefault();

    setIsDisabled(!isDisabled);
  };

  const [columns, setColumns] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const handleReload = async () => {
    setIsLoading(true);
    try {
      const { data } =
        (await apiRequest(
          "get",
          `reservations/?page=${page + 1}&limit=${pageSize}&sortField=${sorting[0]?.id || ""}&sortOrder=${sorting[0]?.desc ? "desc" : "asc"
          }&search=${searchText}`,
          null,
          {},
          {}
        )) || {};

      if (data?.success === true) {
        const sortedRows = data?.data?.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setRows(sortedRows);
        setTotalRows(data?.total);
      }
    } finally {
      setIsLoading(false);
    }
  };


  const column = [
    {
      header: "Status",
      accessorKey: "status",
      filterVariant: "select",
      filterSelectOptions: statusList,
      align: "center",
      fixed: "true",
      size: 190,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },

      Cell: ({ row }) => {
        const status = row.original.status;
        const statusColors = {
          Pending: "yellow",
          Completed: "green",
          Reserved: "blue",
          Cancelled: "red",
          Rejected: "orange",
        };

        const color = statusColors[status] || "yellow";

        return (
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="md"
            style={{ flex: 1, margin: "8px" }}
          >
            <Tag color={color}>{status}</Tag>
          </MDBox>
        );
      },
    },
    {
      header: "Charger ID", size: 190, muiTableHeadCellProps: {
        align: 'justify',
      },
      muiTableBodyCellProps: {
        align: 'justify',
      }, accessorKey: "chargerId", align: "center"
    },

    {
      header: "Driver ID",
      size: 210,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "idTag",
      align: "center",
    },
    {
      header: "Start Time",
      size: 230,
      muiTableHeadCellProps: {
        align: "center",
      },
      enableColumnFilter: false,
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "startTime",
      Cell: ({ cell }) => {
        return convertUTCtoDubai(cell.getValue());
      },
      align: "center",
    },
    {
      header: "End Time",
      size: 210,
      muiTableHeadCellProps: {
        align: "center",
      },
      enableColumnFilter: false,
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "endTime",
      Cell: ({ cell }) => {
        return convertUTCtoDubai(cell.getValue());
      },
      align: "center",
    },
    {
      header: "Connector ID",
      size: 240,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "connectorId",
      align: "center",
    },
    {
      header: "Created By",
      size: 240,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "createdBy",
      align: "center",
    },
    {
      header: "Cancelled By",
      size: 240,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "cancelledBy",
      align: "center",
      Cell: ({ cell }) => {
        return cell.getValue() ? cell.getValue() : "N/A";
      },
    },
    {
      header: "Action",
      size: 190,
      enableColumnFilter: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "action",
      align: "center",
      Cell: (row) =>
        row.row.depth === 0 ? (
          <div
            style={{
              position: "sticky",
              right: "0",
            }}
          >
            {(row?.row?.original?.status === "Pending" ||
              row?.row?.original?.status === "Reserved") && (
                <Tooltip title="Cancel" arrow>
                  <MDButton
                    sx={{
                      marginLeft: 2,
                    }}
                    onClick={() => handleDelete(row?.row?.original)}
                    variant="gradient"
                    color="error"
                    iconOnly
                  >
                    <CloseIcon />
                  </MDButton>
                </Tooltip>
              )}
            {/* Completed (read-only) */}
            {row?.row?.original?.status === "Completed" && (
              <Tooltip title="Completed" arrow>
                <span>
                  <MDButton
                    sx={{ marginLeft: 2 }}
                    variant="gradient"
                    color="success"
                    iconOnly
                    disabled
                  >
                    <CheckCircleIcon />
                  </MDButton>
                </span>
              </Tooltip>
            )}


            {/* Cancelled (read-only) */}
            {row?.row?.original?.status === "Cancelled" && (
              <Tooltip title="Cancelled" arrow>
                <span>
                  <MDButton
                    sx={{ marginLeft: 2 }}
                    variant="gradient"
                    color="error"
                    iconOnly
                    disabled
                  >
                    <BlockIcon />
                  </MDButton>
                </span>
              </Tooltip>
            )}



          </div>
        ) : null,
    },
  ];

  const getPercent = (count, total) => {
    if (!total) return "0.00";
    return ((count / total) * 100).toFixed(2);
  };

  const total = isLoading ? 0 : rows.length;
  const pending = rows.filter((row) => row?.status === "Pending").length;

  const reserved = rows.filter((row) => row?.status === "Reserved").length;
  const rejected = rows.filter((row) => row?.status === "Rejected").length;

  const pendingPercentage = getPercent(pending, total);
  const reservedPercentage = getPercent(reserved, total);
  const rejectedPercentage = getPercent(rejected, total);

  useEffect(() => {
    setColumns(column);
  }, []);
  return (
    <DashboardLayout>
      <PopAddReservation
        isDialog={isDisabled}
        onClose={setIsDisabled}
        value={values}
        onStateChange={handleStateChange}
      />
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={3} mb={8}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                imgicon={TotalCharger}
                title="Total"
                count={total}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="timer"
                title="Pending"
                count={pending}
                percentage={{
                  color: "warning",
                  amount: `${pendingPercentage}%`,
                  label: "of total",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="doneoutlined"
                title="Reserved"
                count={reserved}
                percentage={{
                  color: "success",
                  amount: `${reservedPercentage}%`,
                  label: "of total",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="close"
                title="Rejected"
                count={rejected}
                percentage={{
                  color: "error",
                  amount: `${rejectedPercentage}%`,
                  label: "of total",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ width: "50%" }}
                  >
                    Reservation
                  </MDTypography>

                  <MDBox className="admin_btnsHeaderCont" style={{
                    display: "flex",
                    // width:"50%",
                    justifyContent: "space-between"
                  }}>
                    <MDBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <MDButton
                        onClick={start}
                        color="error"
                        style={{
                          border: "1px solid white",
                          color: "white",
                        }}
                        startIcon={<CalendarToday />}
                      >
                        Create reservation
                      </MDButton>

                      <TableRefreshButton onRefresh={handleReload} loading={isLoading} tooltip="Reload Reservations" />
                    </MDBox>

                  </MDBox>
                </Grid>
              </MDBox>
              {isLoading ? (
                <Loader />
              ) : (
                <CustomMaterialTablePage
                  columns={columns}
                  data={rows}
                  darkMode={darkMode}
                  manualPagination={true}
                  manualFiltering={false}
                  rowCount={totalRows}
                  paginationChange={(newPage) => setPagination(newPage)}
                  soringChange={handleSortingChange}
                  page={page}
                  pagesize={pageSize}
                  paginataion={pagination}
                  sorting={sorting}
                  searchText={searchText}
                  searchChange={handleSearchChange}
                  onColumnFiltersChange={setColumnFilters}
                  onColumnVisibilityChange={setColumnVisibility}
                  state={{
                    pagination,
                    sorting,
                    columnFilters,
                    columnVisibility,
                  }}
                  globalFilterDebounceMs={2000}
                />
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <GlobalStyles
        styles={{
          "@keyframes spin": {
            from: { transform: "rotate(0deg)" },
            to: { transform: "rotate(360deg)" },
          },
        }}
      />

    </DashboardLayout>
  );
}

export default Reservation;
